import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import SkillService from '@/core/services/skill.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateSkillComponent extends Vue {

  skillService: any = new SkillService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  name: string = "";
  scores: any = [];
  value: string = "";
  description: string = "";
  percentage: string = "";

  mounted (){
    const _ = this;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  create(){
    const _ = this;
    let skill = {
      name: _.name,
      scores: [
        {
          value: _.value,
          percentage: _.percentage
        },
      ]
    };
    console.log(skill);
    _.isLoading = true;
    _.skillService.create(skill).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/skill');
      }, 2000)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  validations(name = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("por favor escribe el nombre de la capacidad");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }

}
